import { render, staticRenderFns } from "./SimpleFooter.vue?vue&type=template&id=342c6eff&scoped=true&"
import script from "./SimpleFooter.vue?vue&type=script&lang=js&"
export * from "./SimpleFooter.vue?vue&type=script&lang=js&"
import style0 from "./SimpleFooter.vue?vue&type=style&index=0&id=342c6eff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342c6eff",
  null
  
)

export default component.exports